import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  header: string;
  desc: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const addSourceCustom = async (payload: APIPayload) => {
  try {
    const response = await Axios.post(`/files/add_data_to_qdrant`, payload);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useAddSourceCustom = () => {
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => addSourceCustom(payload),
    onSuccess: (data) => {
      toast.success('Custom Text Added Successfully');
      console.log(data);
    },
    onError: (error) => {
      toast.error('Adding Custom Text Source Failed', {
        description: error.message,
      });
    },
  });
};
